import { render, staticRenderFns } from "./Biaodan.vue?vue&type=template&id=ddfadf72&"
import script from "./Biaodan.vue?vue&type=script&lang=js&"
export * from "./Biaodan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports